import { Container, Box } from '@mui/material'
import React from 'react'
import { BlankViewImageVariants, BlankView } from 'src/Components/blank-view'

const GERMAN_LANGUAGE = 'de'
const AUTH_LOCAL_STORAGE_KEY = 'persist:auth'
const LOCALFORAGE_DATABASE_NAME = 'localforage'

/**
 * Page for unhandled error with a reload functionality to delete all cache except the auth, so the user stays logged in
 */
const UnhandledErrorPage: React.VFC = () => {
  const isGermanLanguage = navigator.language.toLocaleLowerCase().includes(GERMAN_LANGUAGE)
  const title = isGermanLanguage ? 'Oje, da ist etwas schiefgelaufen!' : 'Oh dear, something has gone wrong!'
  const explanation = isGermanLanguage
    ? 'Versuchen Sie die Seite zu aktualisieren oder wenden Sie sich an unseren Support'
    : 'Try to refresh the page or contact our support'
  const actionText = isGermanLanguage ? 'Erneut laden' : 'Refresh'

  /**
   * Deletes localstorage except auth, session storage and indexedDB
   */
  const handleClick = (): void => {
    const auth = localStorage.getItem(AUTH_LOCAL_STORAGE_KEY)
    localStorage.clear()
    sessionStorage.clear()
    if (auth) localStorage.setItem(AUTH_LOCAL_STORAGE_KEY, auth)

    const deletion = indexedDB.deleteDatabase(LOCALFORAGE_DATABASE_NAME)

    deletion.onerror = () => {
      console.log('indexedDb could not be deleted')
      window.location.reload()
    }

    deletion.onsuccess = () => {
      console.log('indexedDb was deleted')
      window.location.reload()
    }
  }

  return (
    <Container data-qa="unhandled-error-page" maxWidth="sm" sx={{ display: 'flex', height: '100vh', flex: 1, alignContent: 'center' }}>
      <Box sx={{ mb: 2, pt: 2 }}>
        <BlankView
          title={title}
          explanation={explanation}
          imageVariant={BlankViewImageVariants.Worried}
          action={{ text: actionText, onClick: handleClick }}
        />
      </Box>
    </Container>
  )
}

export default UnhandledErrorPage
